const exportComponents = {
  // 模型浏览组件
  ModelView: () => {
    return import('../../../components/model/ModelView')
  },
  /** 弹窗组件 */
  SetOriginPoint: () => {
    return import('../../../components/dialog/SetOriginPoint')
  },
  /** 工具类 */
  BasicTab: () => {
    return import('../../../components/tool/BaiscTab')
  },
  /** 基础功能 */
  // 模型树
  ModelTree: () => {
    return import('../../../components/basic/ModelTree')
  },
  /** 业务功能 */
  // 添加模型
  AddModels: () => {
    return import('../../../components/business/AddModels')
  },
  // 视角管理
  ViewAngle: () => {
    return import('../../../components/business/viewAngle')
  },
  // 组态管理
  CompositeState: () => {
    return import('../../../components/business/compositeState')
  },
  // 添加动效
  KineticEffect: () => {
    return import('../../../components/business/KineticEffect')
  },
  // 模型编辑工具
  NodeEditTool: () => {
    return import('../../../components/business/NodeEditTool')
  },
  // 场景动画
  SceneAnimation: () => {
    return import('../../../components/business/SceneAnimation')
  },
  // 区域剖切
  AreaClip: () => {
    return import('../../../components/business/AreaClip.vue')
  },
  // 新增工程模型
  AddEngineering: () => {
    return import('../../../components/business/AddEngineering.vue')
  },
  // 工程动画配置
  EngineeringAnimationConfig: () => {
    return import('../../../components/business/EngineeringAnimationConfig.vue')
  },
}
export default exportComponents
